import Screen, { type ScreenProps } from 'ui/layouts/Screen';
import SupportComponent from 'ui/organizms/Support';

const Support = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Support'
    >
        <SupportComponent />
    </Screen>
);

export default Support;
